import { useCallback } from "react";
import { useAsyncError } from "./application";

const ERRORS_TO_IGNORE = ["AbortError"];

export const useCatchLazyQueryError = () => {
    const throwError = useAsyncError();

    const catchError = useCallback(
        (catchError: Error) => {
            if (!ERRORS_TO_IGNORE.includes(catchError.name)) {
                throwError(catchError);
            }
        },
        [throwError],
    );

    return catchError;
};
